import { useEffect, useState } from 'react';
import Home from './pages/home';
import MentalConditions from './pages/MentalConditions';
import Services from './services/services.jsx';
import TreatmentApproaches from './services/wellnessprograms.jsx';
import Experts from './pages/Experts.jsx';
import Clinics from './pages/Clinics.jsx';
import './App.css';
import About from './pages/about';

function App() {
    const [pathname, setPathname] = useState(() => (typeof window !== 'undefined' ? window.location.pathname : '/'));

    useEffect(() => {
        const handleLocationChange = () => {
            if (typeof window !== 'undefined') setPathname(window.location.pathname);
        };

        // Safe, idempotent patch guarded for non-browser contexts
        if (typeof window !== 'undefined' && window.history && !window.__nexus_history_patched__) {
            // Store originals on window so multiple mounts don't overwrite
            window.__nexus_original_push__ = window.__nexus_original_push__ || window.history.pushState;
            window.__nexus_original_replace__ = window.__nexus_original_replace__ || window.history.replaceState;

            const originalPush = window.__nexus_original_push__.bind(window.history);
            const originalReplace = window.__nexus_original_replace__.bind(window.history);

            window.history.pushState = function (...args) {
                const result = originalPush(...args);
                // emit custom event used by SPA navigation in app
                try {
                    window.dispatchEvent(new Event('locationchange'));
                } catch {
                    const ev = document.createEvent('Event');
                    ev.initEvent('locationchange', true, true);
                    window.dispatchEvent(ev);
                }
                return result;
            };

            window.history.replaceState = function (...args) {
                const result = originalReplace(...args);
                try {
                    window.dispatchEvent(new Event('locationchange'));
                } catch {
                    const ev = document.createEvent('Event');
                    ev.initEvent('locationchange', true, true);
                    window.dispatchEvent(ev);
                }
                return result;
            };

            window.__nexus_history_patched__ = true;
        }

        // Listen for both popstate (back/forward) and our custom event (push/replace)
        if (typeof window !== 'undefined') {
            window.addEventListener('popstate', handleLocationChange);
            window.addEventListener('locationchange', handleLocationChange);
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('popstate', handleLocationChange);
                window.removeEventListener('locationchange', handleLocationChange);
                // Do not unpatch here � unpatching on component unmount can race in dev/strict mode.
            }
        };
    }, []);

    if (pathname.startsWith('/services')) return <Services />;
    if (pathname === '/mentalconditions') return <MentalConditions />;
    if (pathname === '/wellnessprograms') return <TreatmentApproaches />;
    if (pathname.startsWith('/experts')) return <Experts />;
    if (pathname.startsWith('/clinics')) return <Clinics />;
    if (pathname.startsWith('/about')) return <About />;


    return <Home />;
}

export default App;